/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Mission detail container

Author: Deimos Space UK

Version: 1.0
*/

import React, { useState, useEffect } from 'react'
import { Col, Container, Row, Nav, NavItem, NavLink, Button } from "reactstrap";
import classnames from 'classnames';
import { useParams } from "react-router-dom";
import ImpactEvaluation from '../../../impact-evaluation/container/ImpactEvaluation';
import InputView from '../../../input-view/container/InputView';
import { getPetition } from "../../../../api/api";

import style from './MissionDetail.module.css'

export default function MissionDetail() {

    const [activeTab, setActiveTab] = useState('1');
    const { id } = useParams();
    const [missionName, setMissionName] = useState('')
    const [missionVersion, setMissionVersion] = useState('')
    const goBack = () => {
        window.history.back();
    }
    useEffect(() => {
        getPetition(`/api/mission?mission_id=${id}`)
        .then((data) => {
          if (data) {
            setMissionName(data?.name)
            setMissionVersion(data?.version)
          } 
          setMissionName(data?.name)
  
        })
        .catch((error) => {
        })
    }, [id]);

    
    return (
        <Container>
            <Row className="pt-3">
                <Button onClick={()=>goBack()} color='light' className="btn-icon ">
                    <i className="mdi mdi-arrow-left font-20"></i>
                </Button>
            </Row>

            <Row>
                <Col xs={12}>
                    <h3 style={{ color: '#003247' }}> Mission detail {missionName}</h3>
                    <h6 style={{ color: '#003247' }}>Version: {missionVersion}</h6>
                </Col>

            </Row>
            <Row className={style.navContainer} >
                <Nav style={{ width: '100%', marginTop: '20px' }} as="ul" variant="pills" className="nav nav-pills bg-nav-pills nav-justified mb-3">
                   
                    <NavItem style={{ border: '1px solid', background: activeTab === '1' && '#003247' }} as="li" className="nav-item">
                        <NavLink href="#" onClick={() => { setActiveTab('1') }} className="nav-link rounded-0">
                            <i style={{ color: activeTab === '1' && 'white' }} className={classnames('mdi mdi-format-float-left', 'font-20')}></i>
                            <span style={{ color: activeTab === '1' && 'white' }} className="d-none d-lg-block font-15">Input form</span>
                        </NavLink>
                    </NavItem>
                    <NavItem style={{ border: '1px solid', background: activeTab === '2' && '#003247' }} as="li" className="nav-item">
                        <NavLink href="#" onClick={() => { setActiveTab('2') }} className="nav-link rounded-0">
                            <i style={{ color: activeTab === '2' && 'white' }} className={classnames('mdi mdi-view-dashboard-variant', 'font-20')}></i>
                            <span style={{ color: activeTab === '2' && 'white' }} className="d-none d-lg-block  font-15">Debris index values</span>
                        </NavLink>
                    </NavItem>
                </Nav>
            </Row>
            <Row>
                <Col lg={12}>
                    {
                        activeTab === '1' && <InputView />
                    }
                    {
                        activeTab === '2' && <ImpactEvaluation />
                    }
                    
                </Col>

            </Row>
        </Container>
    )
}
